/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Field_ItemsInputs */

const vi_media_field_items = /** @type {(inputs: Media_Field_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dòng trong khối`)
};

/**

* @param {Media_Field_ItemsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const media_field_items = /** @type {((inputs?: Media_Field_ItemsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Field_ItemsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_media_field_items(inputs)
});